module.exports = __webpack_public_path__ + "static/don6-e9d07e94ce58e48fd87b594dcc4258fe.jpg";